export default "__VITE_ASSET__B8dRp4el__"